export const vodafoneExternalLinks = {
  creativeX: 'https://app.creativex.com',
  representation: 'https://app.creativex.com/representation/overview',
  carbonCalculator: 'https://app.cozero.io/',
  discoveryDashboardsByMarket: [
    { market: 'Germany', url: 'https://datastudio.google.com/reporting/3dea5f28-02a1-45cb-aa4f-d76f31342622' },
    { market: 'United Kingdom', url: 'https://datastudio.google.com/reporting/aaa3171c-b865-490e-baf4-af942ac0910d' },
    { market: 'South Africa', url: 'https://datastudio.google.com/reporting/01be94f1-7fc9-4d11-b2b2-7203602f6131' },
    { market: 'Turkey', url: 'https://datastudio.google.com/reporting/91e35e78-afc6-4538-ab19-46ec0a179299' },
    { market: 'Albania', url: 'https://datastudio.google.com/reporting/406963df-112e-47ec-9369-76f7c2e84b95' },
    { market: 'Czech Republic', url: 'https://datastudio.google.com/reporting/080cdbbb-b2a5-4c70-a717-218a058b1257' },
    { market: 'Greece', url: 'https://datastudio.google.com/reporting/9bf126aa-37bb-4cd7-b18d-3312f3107721' },
    { market: 'Ireland', url: 'https://datastudio.google.com/reporting/162aea0b-04d0-4aff-81bd-c9507d79b6fc' },
    { market: 'Portugal', url: 'https://datastudio.google.com/reporting/8d9a123f-b4ce-4fd2-baf9-cf2a5d0b3951' },
    { market: 'Romania', url: 'https://datastudio.google.com/reporting/c87400e3-e50d-4892-8d8f-2f4114571f6b' },
    { market: 'Egypt', url: 'https://datastudio.google.com/reporting/035b399f-03b5-4ff5-b783-5b8273656bc0' },
  ],
}
